import { useNotification } from '@/hooks'

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material'

export interface SimpleDialogProps {
  open: boolean
  data: any
  onClose: (value: boolean) => void
}

export function InvalidEmployerImportDialog(props: SimpleDialogProps) {
  const { __ } = useTranslator()
  const { onClose, data, open } = props

  const n = useNotification()

  console.log(n)

  const handleClose = () => {
    onClose(false)
  }

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      sx={{
        '& .MuiDialog-paper': { overflow: 'visible', maxWidth: '900px' }
      }}
    >
      <DialogTitle>{__('Invalid Template File')}</DialogTitle>
      <DialogContent>
        <Box className='mt-4 rounded-[20px] border border-gray-200 overflow-hidden'>
          <Box sx={{ maxHeight: 350, overflowY: 'auto' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className='text-[13px] font-medium' sx={{ width: '50px' }}>
                    #
                  </TableCell>
                  <TableCell className='text-[13px] font-medium' sx={{ width: '80px' }}>
                    {__('ROW')}
                  </TableCell>
                  <TableCell className='text-[13px] font-medium'>{__('INVALID REASON')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.errors?.map((error: any, index: number) => (
                  <TableRow key={index}>
                    <TableCell className='text-[13px] font-medium' sx={{ width: '50px' }}>
                      {index + 1}
                    </TableCell>
                    <TableCell className='text-[13px] font-medium' sx={{ width: '80px' }}>
                      {error.row || '-'}
                    </TableCell>
                    <TableCell className='text-[13px] font-medium'>{error.error || '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          onClick={() => {
            navigator.clipboard.writeText(
              data?.errors?.map((error: any) => `Row ${error?.row}: ${error?.error}`).join('\n')
            )
            n.success(__('Copied to clipboard'))
          }}
          className='rounded-full'
        >
          {__('Copy All Errors')}
        </Button>
        <Button onClick={handleClose} autoFocus className='hover:rounded-full'>
          {__('Cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
